module.exports = __webpack_public_path__ + "media/5_the_empress.8f95373e.mp3";